export default __webpack_public_path__ + "images/OK.999e53c.png";